import {gql} from "graphql-tag";
import {basePageableGraphqlField, responseField} from "../../../../../store/base.graphql";


export interface InAppNotification {
  id?: string;
  uniqueId?: string;
  title?: string;
  message?: string;
  viewed?: string;
  type?: InAppNotificationTypeChoices;
  relatedUuid?: string;
  createdDate?: string;
}


export const GET_ALL_IN_APP_NOTIFICATION = gql`
query GetAllInAppNotifications($filtering: NotificationFilteringObject) {
  getAllInAppNotifications(filtering: $filtering) {
    response {
      ${responseField}
    }
    page {
      ${basePageableGraphqlField}
    }
    data {
      id
      uniqueId
      title
      message
      viewed
      type
      relatedUuid
      createdDate
    }
  }
}
`

export const VIEW_IN_APP_NOTIFICATION = gql`
mutation ViewInAppNotification($uniqueId: String!) {
  viewInAppNotification(uniqueId: $uniqueId) {
    response {
      ${responseField}
    }
  }
}
`


export enum InAppNotificationTypeChoices {
  ComplaintNotification = 'ComplaintNotification'
}
